<template>
    <div class="container pt-4 pb-3">        
        
        <b-card no-body class="profiletabs mb-3">
            <b-tabs pills card vertical>
                
                <b-tab :title=" $t('Welcome') +' '+userDetails.first_name" content-class="profile-userarea">
                </b-tab>
                <b-tab :title="$t('My Profile')" active>
                    <b-card-text class="profile-section">

                        <!-- PROFILE CONTENT START -->
                        
                        <div class="w-100">
                            <div class="partner-form">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                    
                                        <h2 class="mb-3">{{ $t('Edit Profile') }}</h2>   
                                    
                                        <div v-if="isShow">
                                            <bootstrap-alert 
                                            :variant="response.variant" 
                                            :msg="response.message" 
                                            :errorMsg="response.errmsg" 
                                            />    
                                        </div>

                                        <div v-if="loading" class="loading"></div>
                                        <form class="w-150" @submit.prevent="editRequest" autocomplete="off">
                                            <div class="row">
                                                <div class="col-lg-12 col-xl-12">
                                                    <h3 class="font-16 mt-3 mb-3">{{ $t('Personal Information') }}</h3>
                                                    <div class="row">
                                                        <!-- <div class="col-md-2 col-lg-2 col-xl-2">
                                                            <div class="form-group">
                                                                <label for="salutation">
                                                                    {{ $t('Salutation') }}
                                                                    <span class="required">*</span>
                                                                </label>

                                                                <b-form-select 
                                                                    v-model="form.salutation" 
                                                                    :options="options" 
                                                                    :readonly="true"
                                                                    id="salutation" 
                                                                    name="salutation" 
                                                                    class="form-control" >
                                                                </b-form-select>
                                                            </div>
                                                        </div> -->
                                                        <div class="col-md-5">                  
                                                            <div class="form-group">
                                                                <label for="first_name">
                                                                    {{ $t('Firstname') }}
                                                                    <span class="required">*</span>
                                                                </label>
                                                            
                                                                <b-form-input
                                                                    id="first_name" 
                                                                    name="first_name"
                                                                    type="text"
                                                                    v-model.trim="form.first_name"
                                                                    maxlength="50"
                                                                    required="required"
                                                                    >
                                                                </b-form-input>
                                                            </div>
                                                        
                                                        </div>
                                                        <div class="col-md-5">                  
                                                            <div class="form-group">
                                                                <label for="last_name">
                                                                    {{ $t('Lastname') }}
                                                                    <span class="required">*</span>
                                                                </label>
                                                                <b-form-input
                                                                    id="last_name" 
                                                                    name="last_name"
                                                                    type="text"
                                                                    v-model.trim="form.last_name"
                                                                    maxlength="50"
                                                                    required="required"
                                                                    >
                                                                </b-form-input>
                                                            </div>
                                                        </div>
                                                    </div>
                                                
                                                    <div class="row">
                                                        <div class="col-lg-6 col-md-6 col-xs-12">
                                                            <div class="form-group">            
                                                                <label for="email">
                                                                    {{ $t('Email') }}
                                                                <span class="required">*</span>
                                                                </label>
                                                                <b-form-input
                                                                    type="text" 
                                                                    id="email" 
                                                                    name="email"
                                                                    v-model.trim="form.email"
                                                                    :readonly="true"
                                                                >
                                                                </b-form-input>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-xs-12">
                                                            <div class="form-group">
                                                                <label for="contact_number">
                                                                    {{ $t('Contact Number') }}
                                                                    <span class="required">*</span>
                                                                </label>

                                                                <div class="d-flex" style="height:38px;">
                                                                    
                                                                    <!-- <vue-country-code @onSelect="onSelect"
                                                                        :preferredCountries="['fi', 'vn', 'us', 'gb']"
                                                                        :disabledFetchingCountry="false"
                                                                         v-bind="bindProps"
                                                                        v-model="form.country_code"
                                                                        class="form-control countryflag"
                                                                        >
                                                                    </vue-country-code> -->
                                                                
                                                                    <b-form-input 
                                                                        type="text"  
                                                                        id="contact_number" 
                                                                        name="contact_number" 
                                                                        @keypress="isPhoneNo()"
                                                                        :placeholder="$t('Enter number as 050123123')"
                                                                        v-model.trim="form.contact_number"
                                                                        required="required">
                                                                    </b-form-input>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-6" v-if="form.is_company_user == 1">

                                                            <div class="form-group">
                                                                <label for="company_name">
                                                                {{ $t('Company Name') }}
                                                                <span class="required">*</span>
                                                                </label>
                                                                <input 
                                                                type="text" 
                                                                class="form-control input-field" 
                                                                id="company_name" 
                                                                v-model="form.company_name" 
                                                                name="company_name" 
                                                                placeholder="Company Name"
                                                                required="required" />
                                                            </div>
                                                        </div>

                                                        <div class="col-6" v-if="form.is_company_user == 1">

                                                            <div class="form-group">
                                                                <label for="company_vat_number">
                                                                {{ $t('Company VAT Number') }}
                                                                </label>
                                                                <input 
                                                                type="text" 
                                                                class="form-control input-field" 
                                                                id="company_vat_number" 
                                                                v-model="form.company_vat_number" 
                                                                name="company_vat_number" 
                                                                placeholder="Company VAT Number" />
                                                            </div>
                                                        </div>
                                                    </div> 
                                                </div>

                                                <div class="col-lg-12 col-xl-12">
                                                    <div class="row">
                                                        <div class="col-md-6 col-lg-6">

                                                            <h3 class="font-16 mt-3 mb-3">{{ $t('Billing Address') }}</h3>
                                                            <div class="Billingaddress">
                                                                    <div class="form-group">
                                                                        <label for="address_line_1">
                                                                            {{ $t('Street Name, Building Number') }}
                                                                            <span class="required">*</span>
                                                                        </label>
                                                                        <b-form-input
                                                                            type="text" 
                                                                            id="address_line_1" 
                                                                            name="address_line_1"
                                                                            v-model.trim="form.billingAddress.address_line_1"
                                                                            required="required"
                                                                        >
                                                                        </b-form-input>
                                                                    </div>

                                                                    <!-- <div class="form-group">
                                                                        <label for="address_line_2">
                                                                            {{ $t('Address 2') }}
                                                                            <span class="required">*</span>
                                                                        </label>
                                                                        <b-form-input
                                                                            type="text" 
                                                                            id="address_line_2" 
                                                                            name="address_line_2"
                                                                            v-model.trim="form.billingAddress.address_line_2"
                                                                            required="required"
                                                                        >
                                                                        </b-form-input>
                                                                    </div> -->

                                                                <div class="row">
                                                                    

                                                                    <div class="col-12">

                                                                        <div class="form-group">
                                                                            <label for="zipcode">
                                                                                {{ $t('Zipcode') }}
                                                                                <span class="required">*</span>
                                                                            </label>
                                                                            <b-form-input
                                                                                type="text" 
                                                                                id="zipcode" 
                                                                                name="zipcode"
                                                                                minlength="5"
                                                                                maxlength="5"
                                                                                v-model.trim="form.billingAddress.zipcode"
                                                                                required="required"
                                                                            >
                                                                            </b-form-input>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-5">

                                                                        <div class="form-group">
                                                                            <label for="city">
                                                                                {{ $t('City') }}
                                                                                <span class="required">*</span>
                                                                            </label>
                                                                            <b-form-input
                                                                                type="text" 
                                                                                id="city" 
                                                                                name="city"
                                                                                v-model.trim="form.billingAddress.city"
                                                                                required="required"
                                                                            >
                                                                            </b-form-input>
                                                                        </div>
                                                                    </div>

                                                                    <b-col cols="7">
                                                                        <div class="form-group">
                                                                            <label for="billingAddress['country']">
                                                                                {{ $t('Country') }}
                                                                            </label>
                                                                            <b-form-select for="country" v-model.trim="form.billingAddress.country_id"
                                                                            id="billingAddress['country']"
                                                                            name="billingAddress['country']">
                                                                                <option :value="null">{{ $t('Please select country') }}</option>
                                                                                <option v-for="(country) in countriesList" :key="country.id" :value="country.id"  >{{ country.name  }}</option>
                                                                            </b-form-select>
                                                                        </div>
                                                                    </b-col>
                                                                
                                                                </div>
                                                            </div>
                                                            <div class="col-12">
                                                                <p><b-form-checkbox
                                                                id="checkbox-1"
                                                                v-model="form.billingAddress.isSameAddress"
                                                                @change="sameAddress($event)"
                                                                name="checkbox-1"
                                                                value="1"
                                                                unchecked-value="0"
                                                                > {{ $t('Same as billing address') }}
                                                                </b-form-checkbox></p>
                                                            </div>

                                                        </div>    


                                                        <div class="col-md-6 col-lg-6">
                                                            <h3 class="font-16 mt-3 mb-3">{{ $t('Shipping Address') }}</h3>
                                                            <div class="Billingaddress">
                                                                <div class="form-group">
                                                                    <label for="address_line_1">
                                                                        {{ $t('Street Name, Building Number') }}
                                                                        <span class="required">*</span>
                                                                    </label>
                                                                    <b-form-input
                                                                        type="text" 
                                                                        id="address_line_1" 
                                                                        name="address_line_1"
                                                                        :readonly="form.billingAddress.isSameAddress == 1"
                                                                        v-model.trim="form.shippingAddress.address_line_1"
                                                                        required="required"
                                                                    >
                                                                    </b-form-input>
                                                                </div>

                                                                <!-- <div class="form-group">
                                                                    <label for="address_line_2">
                                                                        {{ $t('Address 2') }}
                                                                        <span class="required">*</span>
                                                                    </label>
                                                                    <b-form-input
                                                                        type="text" 
                                                                        id="address_line_2" 
                                                                        name="address_line_2"
                                                                        :readonly="form.billingAddress.isSameAddress == 1"
                                                                        v-model.trim="form.shippingAddress.address_line_2"
                                                                        required="required"
                                                                    >
                                                                    </b-form-input>
                                                                </div> -->

                                                                <div class="row">
                                                                    <div class="col-12">

                                                                        <div class="form-group">
                                                                            <label for="zipcode">
                                                                                {{ $t('Zipcode') }}
                                                                                <span class="required">*</span>
                                                                            </label>
                                                                            <b-form-input
                                                                                type="text" 
                                                                                id="zipcode" 
                                                                                name="zipcode"
                                                                                minlength="5"
                                                                                maxlength="5"
                                                                                :readonly="form.billingAddress.isSameAddress == 1"
                                                                                v-model.trim="form.shippingAddress.zipcode"
                                                                                required="required"
                                                                            >
                                                                            </b-form-input>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-5">

                                                                        <div class="form-group">
                                                                            <label for="city">
                                                                                {{ $t('City') }}
                                                                                <span class="required">*</span>
                                                                            </label>
                                                                            <b-form-input
                                                                                type="text" 
                                                                                id="city" 
                                                                                name="city"
                                                                                v-model.trim="form.shippingAddress.city"
                                                                                :readonly="form.billingAddress.isSameAddress == 1"
                                                                                required="required"
                                                                            >
                                                                            </b-form-input>
                                                                        </div>
                                                                    </div>

                                                                    <b-col cols="7">
                                                                        <div class="form-group">
                                                                            <label for="shippingAddress['country']">
                                                                                {{ $t('Country') }}
                                                                            </label>
                                                                            <b-form-select for="country" v-model.trim="form.shippingAddress.country_id"
                                                                            id="shippingAddress['country']"
                                                                            name="shippingAddress['country']">
                                                                                <option :value="null">{{ $t('Please select country') }}</option>
                                                                                <option v-for="(country) in countriesList" :key="country.id" :value="country.id"  >{{ country.name  }}</option>
                                                                            </b-form-select>
                                                                        </div>
                                                                    </b-col>
                                                                
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <button 
                                                type="submit" 
                                                class="btn d-block w-100 login-button color-white bg-black pt-2 pb-2"
                                                >{{ $t('Update Profile') }}</button>
                                        </form>

                                    </div>
                                </div>

                            </div>
                        </div>

                        <!-- PROFILE CONTENT END  -->
                    
                    </b-card-text>
                </b-tab>
                <b-tab :title="$t('Orders')">
                    <b-card-text class="profile-section">
                        
                        <div v-if="!orderdetail">
                            <h2 class="mb-3">{{ $t('Orders') }}</h2>

                            <b-row class="border-bottom">
                                <b-col>
                                    <div class="table-scroll">
                                        <table class="table my-4">
                                            <thead>
                                                <!-- <th v-for="field in fields" :key="field.key">{{field.label}}</th> -->
                                                <th>#</th>
                                                <th>{{ $t('Order Number') }}</th>
                                                <th>{{ $t('Order Date') }}</th>
                                                <th>{{ $t('Order Amount') }}</th>
                                                <th>{{ $t('Payment Status') }}</th>
                                                <th>{{ $t('Action') }}</th>
                                            </thead>
                                            <tbody>
                                                <tr scope="row" v-for="(order, index) in orders" :key="order.id">
                                                    <td>{{index + 1}}</td>
                                                    <td>{{order.order_number}}</td>
                                                    <td>
                                                        <span v-if="order.order_status == 'paid'">{{order.paid_on}}</span>
                                                        <span v-else>{{order.created_at}}</span>    
                                                    </td>
                                                    <td><span v-html="setCurrency(order.total)"></span></td>
                                                    <td>
                                                        <span v-if="order.order_status == 'paid'">{{ $t('Paid') }}</span>
                                                        <span v-if="order.order_status == 'unpaid'">{{ $t('Unpaid') }}</span>
                                                    </td>
                                                    <td>
                                                        <button class="btn bg-yellow" @click="orderDetail(order.id)">{{ $t('View') }}</button>
                                                    </td>
                                                </tr>
                                                <tr v-if="orders.length == 0">
                                                    <td colspan="6"><center>{{ $t('No orders found') }}</center></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>

                        <div v-if="orderdetail">

                            <div class="cal-md-12 mb-3 d-flex align-items-center justify-content-between">
                                <h2 class="mb-0">{{ $t('Order details') }}</h2>
                                <button class="btn bg-yellow pl-3 pr-3" @click="backOrders()">{{ $t('Back') }}</button>
                            </div>
                            <b-container class="bv-example-row pl-0 pr-0">

                                <b-card header-tag="header">
                                    <template v-slot:header>
                                        <h5 class="font-weight-bold color-black">{{ $t('Order') }}: #{{orderDetails.order_number}} </h5>
										<div class="row">
										<div class="col-sm-6">
                                        <small class="color-black">
                                            <div><span class="font-weight-bold">{{ $t('Order Date') }}: </span>
                                                <span v-if="orderDetails.order_status == 'paid'">{{orderDetails.paid_on}}</span>
                                                <span v-else>{{orderDetails.created_at}}</span>                                          
                                            </div>
                                            <div>
                                                <span class="font-weight-bold">{{ $t('Status') }}: </span> 
                                                <span v-if="orderDetails.order_status == 'paid'" class="text-success">{{ $t('Paid') }}</span>
                                                <span v-if="orderDetails.order_status == 'unpaid'" class="text-danger">{{ $t('Unpaid') }}</span>
                                            </div>
                                            <div>
                                                <span class="font-weight-bold">{{ $t('Type') }}: </span>
                                                    <span v-if="orderDetails.order_type == 'service_point_delivery'">{{ $t('Delivery to service point') }}</span>
                                                    <span v-else>
                                                        <span v-if="isMounting">{{ $t('Installation') }} </span>
                                                        <span v-if="!isMounting">{{ $t('Without installation') }}</span>
                                                    </span> 
                                                </div>
                                            <div><span class="font-weight-bold">{{ $t('Licence Plate') }} : </span> <span v-if="orderDetails.licence_plate && orderDetails.licence_plate != 'null' ">{{orderDetails.licence_plate}}</span> </div>
                                        </small>
										</div>
										<div class="col-sm-6 text-right">
											<!-- <button v-if="orderDetails.invoice_path" class="btn btn-dark"><a target="_blank" class="color-white" :href="orderDetails.invoice_base_path+orderDetails.invoice_path">{{ $t('Download Invoice') }}</a></button> -->
                                            <button v-if="orderDetails.invoice_path && orderDetails.order_status == 'paid'" class="btn btn-dark" @click="downloadInvoice(orderDetails.order_number)">{{ $t('Download Invoice') }}</button>
										</div>
									</div>
                                    </template>
                                    <b-card-text>

                                        <b-row>
                                            <b-col class="border mx-2 px-0 ordercustomer-details">
                                                <h6 class="border-bottom py-3 text-center font-weight-bold font-italic">{{ $t('Customer billing details') }}</h6>
                                                <div class="table-scroll">
                                                    <table class="table table-striped">
                                                        <tbody>
                                                            <tr><td>{{ $t('Name') }}</td> <td><p v-if="orderDetails.billing_details">{{orderDetails.billing_details.first_name}} {{orderDetails.billing_details.last_name}}</p></td> </tr>
                                                            <tr><td>{{ $t('Email') }}</td><td><p v-if="orderDetails.billing_details">{{orderDetails.billing_details.email}}</p></td></tr>
                                                            <tr><td>{{ $t('Contact Number') }}</td><td><p v-if="orderDetails.billing_details">{{orderDetails.billing_details.contact_number}}</p></td></tr>
                                                            <tr><td>{{ $t('Billing Address') }}</td>
                                                                <td>
                                                                    <p v-if="orderDetails.billing_details">
                                                                        {{orderDetails.billing_details.address_line_1}} <br>
                                                                        {{orderDetails.billing_details.zipcode}}
                                                                    </p>                                                                
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <h6 v-if="isMounting && orderDetails.appointment" class="border-bottom border-top border-left-0 border-right-0 py-3 text-center font-weight-bold font-italic">{{ $t('Service Point Details') }}</h6>
                                                <div v-if="isMounting && orderDetails.appointment">
                                                    <table class="table table-striped">
                                                        <tbody>
                                                            <tr><td>{{ $t('Company Name') }}</td><td><p v-if="orderDetails.appointment.dealer">{{orderDetails.appointment.dealer.company_name}}</p></td></tr>
                                                            <tr><td>{{ $t('Email') }}</td><td><p v-if="orderDetails.appointment.dealer">{{orderDetails.appointment.dealer.email}}</p></td></tr>
                                                            <tr><td>{{ $t('Contact Number') }}</td><td><p v-if="orderDetails.appointment.dealer">{{orderDetails.appointment.dealer.contact_number}}</p></td></tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </b-col>
                                            <b-col class="border mx-2 px-0  ordercustomer-details">
                                                <h6 class="border-bottom py-3 text-center font-weight-bold font-italic">{{ $t('Shipping details') }}</h6>
                                                <div class="table-scroll">
                                                    <table class="table table-striped">
                                                        <tbody>
                                                            <tr v-if="orderDetails.order_type == 'service_point_delivery'">
                                                                <td>{{ $t('Company name') }}</td> 
                                                                <td>
                                                                    <p v-if="orderDetails.service_point_shipment_details">{{orderDetails.service_point_shipment_details.company_name}}</p>
                                                                </td>
                                                            </tr>
                                                            <tr v-else><td>{{ $t('Name') }}</td> <td><p v-if="orderDetails.shipping_details">{{orderDetails.shipping_details.first_name}} {{orderDetails.shipping_details.last_name}}</p></td> </tr>
                                                            <tr><td>{{ $t('Email') }}</td><td><p v-if="orderDetails.shipping_details">{{orderDetails.shipping_details.email}}</p></td></tr>
                                                            <tr><td>{{ $t('Contact Number') }}</td><td><p v-if="orderDetails.shipping_details">{{orderDetails.shipping_details.contact_number}}</p></td></tr>
                                                            <tr><td>{{ $t('Shipping Address') }}</td>
                                                                <td>
                                                                    <p v-if="orderDetails.shipping_details">
                                                                        {{orderDetails.shipping_details.address_line_1}} <br>
                                                                        {{orderDetails.shipping_details.zipcode}}
                                                                    </p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <h6 v-if="isMounting && orderDetails.appointment" class="border-bottom border-top py-3 text-center font-weight-bold font-italic">{{ $t('Appointment details') }}</h6>
                                                <div v-if="isMounting && orderDetails.appointment">
                                                    <table class="table table-striped">
                                                        <tbody>
                                                            <tr><td>{{ $t('Appointment date') }}</td><td>{{orderDetails.appointment.schedule_date}}</td></tr>
                                                            <tr><td>{{ $t('Appointment time') }}</td><td>{{orderDetails.appointment.start_time}}</td></tr>
                                                            <tr>
                                                                <td>{{ $t('Address') }}</td>
                                                                <td>
                                                                    <div>{{ orderDetails.appointment.dealer.address_line_1 }}</div> 
                                                                    <div>{{ orderDetails.appointment.dealer.zipcode }}</div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </b-col>
                                        </b-row>
                                        
                                        <b-row class="border-bottom">
                                            <b-col>
                                                <div class="table-scroll">
                                                    <table class="table my-4">
                                                        <thead class="text-center">
                                                            <th scope="col" class="text-left">{{ $t('Product Name') }}</th>
                                                            <th scope="col">{{ $t('Unit Price') }}</th>
                                                            <th scope="col">{{ $t('Quantity') }}</th>
                                                            <th scope="col">{{ $t('Total') }}</th>
                                                        </thead>
                                                        <tbody class="text-center">

                                                            <tr scope="row" v-for="orderProductDetail in orderDetails.line_items" :key="`product_`+orderProductDetail.id">
                                                                <td v-if="orderProductDetail.type == 'product'" class="text-left">{{orderProductDetail.product.name}}
                                                                    <div class="rc-label" v-if="orderProductDetail.product.is_recycled == '0'">
                                                                        <small>({{ $t('Recycling fee included') }})</small>
                                                                    </div>
                                                                </td>
                                                                <td v-if="orderProductDetail.type == 'product'">
                                                                    <template v-if="orderProductDetail.product.is_recycled == '0' && recyclingCharge">
                                                                        <span v-html="setCurrency((parseFloat(orderProductDetail.unit_price) + parseFloat(recyclingCharge)).toFixed(2))"></span>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span v-html="setCurrency(orderProductDetail.unit_price)"></span>
                                                                    </template>
                                                                </td>
                                                                <!-- <td v-if="orderProductDetail.type == 'product'"><span v-html="setCurrency(orderProductDetail.unit_price)"></span></td> -->
                                                                <td v-if="orderProductDetail.type == 'product'">{{orderProductDetail.quantity}}</td>
                                                                <td v-if="orderProductDetail.type == 'product'">
                                                                    <template v-if="orderProductDetail.product.is_recycled == '0' && recyclingCharge">
                                                                        <span v-html="setCurrency(((parseFloat(orderProductDetail.unit_price) + parseFloat(recyclingCharge))*orderProductDetail.quantity).toFixed(2))"></span>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span v-html="setCurrency(orderProductDetail.sub_total)"></span>
                                                                    </template>
                                                                </td>
                                                            </tr>

                                                            <!-- <tr scope="row" v-for="orderProductDetail in orderDetails.line_items" :key="`recycling_charges`+orderProductDetail.id" v-if="orderProductDetail.type == 'recycling_charges'">
                                                                <td v-if="orderProductDetail.type == 'recycling_charges'" class="text-left">{{ $t('Recycling fees') }}</td>
                                                                <td v-if="orderProductDetail.type == 'recycling_charges'"><span v-html="setCurrency(orderProductDetail.unit_price)"></span></td>
                                                                <td v-if="orderProductDetail.type == 'recycling_charges'">{{orderProductDetail.quantity}}</td>
                                                                <td v-if="orderProductDetail.type == 'recycling_charges'"><span v-html="setCurrency(orderProductDetail.sub_total)"></span></td>
                                                            </tr> -->

                                                            <tr scope="row" v-for="orderProductDetail in orderDetails.line_items" :key="`service_`+orderProductDetail.id" v-if="orderProductDetail.type == 'service'">
                                                                <td v-for="serviceTranslation in orderProductDetail.service.translations" v-if="serviceTranslation.locale_code == currentLang" class="text-left">{{ serviceTranslation.name }}</td>
                                                                <td v-if="orderProductDetail.type == 'service'"><span v-html="setCurrency(orderProductDetail.unit_price)"></span></td>
                                                                <td v-if="orderProductDetail.type == 'service'">{{orderProductDetail.quantity}}</td>
                                                                <td v-if="orderProductDetail.type == 'service'"><span v-html="setCurrency(orderProductDetail.sub_total)"></span></td>
                                                            </tr>
                                                        
                                                            <tr scope="row" v-for="orderProductDetail in orderDetails.line_items" :key="orderProductDetail.id" v-if="orderProductDetail.type == 'shipping_charges'">
                                                                <td v-if="orderProductDetail.type == 'shipping_charges'" class="text-left">{{$t('Shipping Cost')}}</td>
                                                                <td v-if="orderProductDetail.type == 'shipping_charges'"></td>
                                                                <td v-if="orderProductDetail.type == 'shipping_charges'"></td>
                                                                <td v-if="orderProductDetail.type == 'shipping_charges'"><span v-html="setCurrency(orderProductDetail.sub_total)"></span></td>
                                                            </tr>

                                                            <tr v-if="orderDetails.discount_amount > 0">
                                                                <td colspan="3" class="text-right font-weight-bold">{{ $t('Discount') }}:</td>
                                                                <td v-html="setCurrency(orderDetails.discount_amount)"></td>
                                                            </tr>

                                                            <tr scope="row">
                                                                <td colspan="3" class="text-right font-weight-bold">{{$t('Order amount(Inclusive VAT)')}}:</td>
                                                                <td><span v-if="orderDetails.sub_total" v-html="setCurrency(orderDetails.total)"></span></td>
                                                            </tr>

                                                            <tr scope="row">
                                                                <td colspan="3" class="text-right font-weight-bold">{{$t('VAT Amount')}}:</td>
                                                                <td><span v-if="orderDetails.vat_amount" v-html="setCurrency(orderDetails.vat_amount)"></span></td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </b-col>
                                        </b-row>

                                        <b-row class="py-4">
                                            <div class="col-lg-4 col-md-4 col-xs-12">{{$t('Remarks')}}</div>
                                            <div class="col-lg-8 col-md-8 col-xs-12"> {{ orderDetails.order_note }} </div>
                                        </b-row>

                                    </b-card-text>
                                </b-card>

                            </b-container>
                        </div>
                    </b-card-text>
                </b-tab>
                <!-- <b-tab v-if="detshow" title="Order detail">
                    <b-card-text class="profile-section">
                                <h2 class="mb-3">{{ $t('Orders') }}</h2>
                                <b-table 
                                    class="font-16" 
                                    hover 
                                    :fields="fields"  
                                    :items="orders" 
                                    responsive>

                                    <template v-slot:cell(index)="data">
                                        {{ data.index + 1 }}
                                    </template>

                                    <template v-slot:cell(actions)="row" class="grid-actions">
                                        
                                        <router-link class="color-black font-weight-bold" :to="{ name: 'order-detail', params:{'orderid': row.item.id} }">View</router-link>
                                    </template>
                                </b-table>
                    </b-card-text>
                </b-tab> -->
                <b-tab :title="$t('Change Password')">
                    <b-card-text class="profile-section">
                        
                        <!-- <router-link
                            :to="{ name: 'changepassword'}">
                            <span> {{ $t('Change Password') }} </span>
                        </router-link> -->
                        
                        <change-password></change-password>

                    </b-card-text>
                </b-tab>
                <b-tab :title="$t('Logout')" v-if="loggedIn" @click="userLogout()"></b-tab>
            </b-tabs>
        </b-card>

    </div>
</template>
<script>

import { mapGetters, mapActions } from "vuex";
import Vue from "vue";
import VueCountryCode from "vue-country-code";
import allCountries from "../utils/allCountries";
import ChangePassword from './../components/ChangePassword';
// import getCountry from "../utils/defaultCountry";

Vue.use(VueCountryCode);
export default {
    // props:{
    //     userDetails: Object,
    //     customerDetails: Object
    // },
    metaInfo: {
        title: 'Profile',
        meta: [
            {name: 'description', content: 'This is my profile page'}
        ],
        link: [
            {rel: 'canonical', href: process.env.VUE_APP_BASE_URL + 'profile'}
        ]
    },
    components: {
        'change-password': ChangePassword
    },
    watch: {
        'form.billingAddress.address_line_1': {
            handler(newValue, oldValue) {
                if(this.form.billingAddress.isSameAddress == 1) {
                    this.form.shippingAddress.address_line_1 = this.form.billingAddress.address_line_1;
                }
            }
        },
        'form.billingAddress.address_line_2': {
            handler(newValue, oldValue) {
                if(this.form.billingAddress.isSameAddress == 1) {
                    this.form.shippingAddress.address_line_2 = this.form.billingAddress.address_line_2;
                }
            }
        },
        'form.billingAddress.zipcode': {
            handler(newValue, oldValue) {
                if(this.form.billingAddress.isSameAddress == 1) {
                    this.form.shippingAddress.zipcode = this.form.billingAddress.zipcode;
                }
            }
        },
        'form.billingAddress.isSameAddress': {
            handler(newValue, oldValue) {

                if(newValue == 1) {
                    this.form.shippingAddress.address_line_1 = this.form.billingAddress.address_line_1;
                    this.form.shippingAddress.zipcode = this.form.billingAddress.zipcode;
                    this.form.shippingAddress.address_line_2 = this.form.billingAddress.address_line_2;
                    this.form.shippingAddress.country_id = this.form.billingAddress.country_id;
                    this.form.shippingAddress.city = this.form.billingAddress.city;
                }
            }
        },
        'form.billingAddress.country_id': {
            handler(newValue, oldValue) {
                if(this.form.billingAddress.isSameAddress == 1) {
                    this.form.shippingAddress.country_id = this.form.billingAddress.country_id;
                }
            }
        },
        'form.billingAddress.city': {
            handler(newValue, oldValue) {
                if(this.form.billingAddress.isSameAddress == 1) {
                    this.form.shippingAddress.city = this.form.billingAddress.city;
                }
            }
        },
        '$route.params': {
            async handler(newValue, oldValue) {

                // if(Object.keys(newValue).length != 0) {
                //      this.detshow = true;
                //      this.tabIndex = 2;
                // }
            },
            immediate: true
        },
        orderDetails: {
            handler(newValue, oldValue) {
                
                this.isMounting = false;

                if(newValue.line_items) {
                    newValue.line_items.find((el) => {
                        if(el.type == "service") {
                            this.isMounting = true;
                        }
                    })
                }
            }
        }
    },
    data() {
        return {
            count: 0,
            fields: [
                // A virtual column that doesn't exist in items
                { key: 'number', label: '#' },
                // 'index',
                // A column that needs custom formatting
                { key: 'id', label: 'Order Number' },
                // A regular column
                { key: 'created_at', label: 'Order Date' },
                // A regular column
                {key: 'total', label: 'Order Amount'},
                // A virtual column made up from two fields
                { key: 'order_status', label: 'Payment Status' },
                { key: 'actions', label: 'Action' },
            ],
            items: [
                { No: 1, id: '#225', order_date:'12.02.2020', order_amount: '$256', order_status:'Completed', view_order:'View', slot_name: "view" },
                { No: 2, id: '#3256', order_date:'11.02.2020', order_amount: '$254', order_status:'Completed', view_order:'View'  },
                { No: 3, id: '#456', order_date:'10.02.2020', order_amount: '$156', order_status:'Pending', view_order:'View'  },
                { No: 4, id: '#9658', order_date:'9.02.2020', order_amount: '$200', order_status:'Pending', view_order:'View'  }
            ],
            errors: [],
            form: {
                salutation: "",
                first_name: "",
                last_name: "",
                email: "",
                country_code: "358",
                contact_number: "",
                is_company_user: "1",
                company_name: "",
                company_vat_number: "",
                // address_line_1: "",
                // address_line_2: "",
                // zipcode: "",
                billingAddress: {
                    address_line_1: "",
                    address_line_2: "",
                    zipcode: "",
                    city: "",
                    country_id: "73",
                    isSameAddress: '1'
                },
                shippingAddress: {
                    address_line_1: "",
                    address_line_2: "",
                    zipcode: "",
                    city: "",
                    country_id: "73"
                }
            },
            bindProps: {
                defaultCountry: "FI"
            },
            bindPropsMyProfile: {
                defaultCountry: ""
            },
            options: [
                { value: 'mr', text: 'Mr' },
                { value: 'miss', text: 'Miss' },
                { value: 'mrs', text: 'Mrs' }
            ],
            detshow: false,
            orderdetail: false,
            moneySign: "€",
            isMounting: false,
            recyclingCharge: null
        }
    },
    computed: {
        ...mapGetters('countryListing', [ 'countriesList' ]),
        ...mapGetters('editprofile', ['response', 'isShow', 'loading', 'profileDetails']),
        ...mapGetters('app', ['currentLang']),
        ...mapGetters('order', ['orders', 'orderDetails']),
        ...mapGetters('auth', [
            'userDetails',
            'loggedIn',
            'authenticating',
            'authenticationError',
            'authenticationErrorCode',
            'authenticationSuccess',
            'virtualUserDetails',
            'userPermission',
            'userDetailsAddress'
        ]),
    },
    async created() {
        this.resetError();
        this.moneySign = process.env.VUE_APP_CURRENCY_SIGN;

        await this.getProfileDetail(this.userDetails.id);
        this.fetchCountries()   

        this.bindProfileDetailsToView(this.profileDetails)
        this.getOrders();
    },
    methods: {
        ...mapActions('countryListing', ['fetchCountries']),
        ...mapActions('editprofile', ['editProfileRequest', 'getProfileDetail', 'showError', 'resetError']),
        ...mapActions('order', ['getOrders', 'getOrderDetails', 'downloadInvoiceReceipt']),
        ...mapActions('auth', [
            'logout',
            'memberLogout',
            'getVirtualUserDetails',
            'setIsLoggedIn'
        ]),
        ...mapActions('cart', ['clearCartProducts']),
        editRequest() {
            var setflag = true;
            this.errors = [];
            if (!this.form.first_name) {
                setflag = false;
                this.errors.push(this.$t('First Name is required.'));
            }

            if (!this.form.last_name) {
                setflag = false;
                this.errors.push(this.$t('Last Name is required.'));
            }

            if (!this.form.email) {
                setflag = false;
                this.errors.push(this.$t('Email is required.'));
            } else {
                var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
                
                var valid = regex.test(this.form.email);
                if (!valid) {
                    setflag = false;
                    this.errors.push(this.$t('Email is not valid.'));
                }
            }

            if (this.form.billingAddress.zipcode.length != 5) { 
                setflag = false;
                this.errors.push(this.$t('Zipcode allow only 5 character.'));
            }

            if (this.form.shippingAddress.zipcode.length != 5) { 
                setflag = false;
                this.errors.push(this.$t('Zipcode allow only 5 character.'));
            }
            
            if(setflag) {
                this.resetError();

                this.editProfileRequest({
                    first_name: this.form.first_name, 
                    last_name: this.form.last_name,
                    email: this.form.email,
                    salutation : this.form.salutation,
                    country_code : this.form.country_code,
                    contact_number : this.form.contact_number,
                    is_company_user: this.form.is_company_user,
                    company_name: this.form.company_name,
                    company_vat_number: this.form.company_vat_number,
                    address_line_1: this.form.billingAddress.address_line_1,
                    address_line_2: this.form.billingAddress.address_line_2,
                    zipcode: this.form.billingAddress.zipcode,
                    city: this.form.billingAddress.city,
                    same_as_shipping: this.form.billingAddress.isSameAddress,
                    address_type: "0",
                    country_id: this.form.billingAddress.country_id
                    // oldEmail: this.userDetails.email,
                    // lang : this.currentLang
                })
                .then((response) => {
                    this.bindProfileDetailsToView(this.profileDetails)
                    this.$bvModal.hide('edit-profile')
                })
                .catch((error) => {
                    console.error("errors", error)
                });

                //shipping address change
                this.editProfileRequest({
                    first_name: this.form.first_name, 
                    last_name: this.form.last_name,
                    email: this.form.email,
                    salutation : this.form.salutation,
                    country_code : this.form.country_code,
                    contact_number : this.form.contact_number,
                    is_company_user: this.form.is_company_user,
                    company_name: this.form.company_name,
                    company_vat_number: this.form.company_vat_number,
                    address_line_1: this.form.shippingAddress.address_line_1,
                    address_line_2: this.form.shippingAddress.address_line_2,
                    city: this.form.shippingAddress.city,
                    zipcode: this.form.shippingAddress.zipcode,
                    address_type: "1",
                    country_id: this.form.shippingAddress.country_id,
                    // oldEmail: this.userDetails.email,
                    // lang : this.currentLang
                })
                .then((response) => {
                     this.bindProfileDetailsToView(this.profileDetails)
                    this.$bvModal.hide('edit-profile')
                })
                .catch((error) => {
                    console.error("errors", error)
                });

            } else {
                this.showError({'msg': '', 'errors': this.errors});
            }
        },
        bindProfileDetailsToView(profileDetails){
            if(profileDetails.userDetails.country_code != null) {
                this.findCountry(profileDetails.userDetails.country_code);
            }

            this.form.salutation = profileDetails.userDetails.salutation;
            this.form.first_name = profileDetails.userDetails.first_name;
            this.form.last_name = profileDetails.userDetails.last_name;
            this.form.email = profileDetails.userDetails.email;
            this.form.country_code = profileDetails.userDetails.country_code;
            this.form.contact_number = profileDetails.userDetails.contact_number;
            this.form.is_company_user= (profileDetails.userDetails.is_company_user) ? profileDetails.userDetails.is_company_user : "0";
            this.form.company_name= profileDetails.userDetails.company_name;
            this.form.company_vat_number= profileDetails.userDetails.company_vat_number;
            

            this.form.billingAddress.address_line_1 = (profileDetails.userAddress.billingAddress && profileDetails.userAddress.billingAddress.length != 0) ? profileDetails.userAddress.billingAddress.address_line_1: "";
            this.form.billingAddress.address_line_2 = (profileDetails.userAddress.billingAddress && profileDetails.userAddress.billingAddress.length != 0) ? profileDetails.userAddress.billingAddress.address_line_2: "";
            this.form.billingAddress.zipcode = (profileDetails.userAddress.billingAddress && profileDetails.userAddress.billingAddress.length != 0) ? profileDetails.userAddress.billingAddress.zipcode: "";
            this.form.billingAddress.isSameAddress = (profileDetails.userAddress.billingAddress && profileDetails.userAddress.billingAddress.length != 0) ? profileDetails.userAddress.billingAddress.same_as_shipping: "1";
            this.form.billingAddress.country_id = (profileDetails.userAddress.billingAddress && profileDetails.userAddress.billingAddress.length != 0) ? profileDetails.userAddress.billingAddress.country_id: 73;
            this.form.billingAddress.city = (profileDetails.userAddress.billingAddress && profileDetails.userAddress.billingAddress.length != 0) ? profileDetails.userAddress.billingAddress.city: "";
            
            this.form.shippingAddress.address_line_1 = (profileDetails.userAddress.shippingAddress && profileDetails.userAddress.shippingAddress.length != 0) ? profileDetails.userAddress.shippingAddress.address_line_1: "";
            this.form.shippingAddress.address_line_2 = (profileDetails.userAddress.shippingAddress && profileDetails.userAddress.shippingAddress.length != 0) ? profileDetails.userAddress.shippingAddress.address_line_2: "";
            this.form.shippingAddress.zipcode = (profileDetails.userAddress.shippingAddress && profileDetails.userAddress.shippingAddress.length != 0) ? profileDetails.userAddress.shippingAddress.zipcode: "";
            this.form.shippingAddress.country_id = (profileDetails.userAddress.shippingAddress && profileDetails.userAddress.shippingAddress.length != 0) ? profileDetails.userAddress.shippingAddress.country_id: 73;
            this.form.shippingAddress.city = (profileDetails.userAddress.shippingAddress && profileDetails.userAddress.shippingAddress.length != 0) ? profileDetails.userAddress.shippingAddress.city: "";

            if(this.form.billingAddress.isSameAddress == 1) {
                this.form.shippingAddress.address_line_1 = this.form.billingAddress.address_line_1;
                this.form.shippingAddress.zipcode = this.form.billingAddress.zipcode;
                this.form.shippingAddress.address_line_2 = this.form.billingAddress.address_line_2;
                this.form.shippingAddress.country_id = this.form.billingAddress.country_id;
                this.form.shippingAddress.city = this.form.billingAddress.city;
            }
        },
        onSelect({name, iso2, dialCode}) {
            this.form.country_code = dialCode;
        },
        findCountry(dialCode = "") {
            var currentCompany = allCountries.find(country => country.dialCode === dialCode);
            // this.bindProps.defaultCountry = currentCompany.iso2;

            if(currentCompany){
                this.bindPropsMyProfile.defaultCountry = currentCompany.iso2;
                this.bindProps.defaultCountry = currentCompany.iso2;
            }
        },
        sameAddress(status){
            // if(this.form.billingAddress.isSameAddress == 1) {
            //     this.form.shippingAddress.address_line_1 = this.form.billingAddress.address_line_1;
            //     this.form.shippingAddress.address_line_2 = this.form.billingAddress.address_line_2;
            //     this.form.shippingAddress.zipcode = this.form.billingAddress.zipcode;
            // }
        },
        userLogout() {
            // this.setCurrentLogoutTime();
            localStorage.removeItem('userDetails');
            localStorage.removeItem('userDetailsAddress');

            this.logout()
            this.clearCartProducts()
            this.klaviyoIdentifyUser();
            this.$router.push({ 
                        name: '/login',
                        replace: true
                    })
            this.$router.go(0);

            // var self = this;

            // self.logout()
            // self.$router.go({ 
            //     path: '/login', params: {  } 
            // })
        },
        orderDetail(orderid) {
            this.orderdetail = true;
            this.getOrderDetails(orderid)
            .then(response => {
                this.orderDetails.line_items.forEach((orderProductDetail) => {
                    if (orderProductDetail.type == 'recycling_charges') {
                        this.recyclingCharge = orderProductDetail.unit_price
                    }
                })
                window.scrollTo(0,0)
            });
        },
        backOrders() {
            this.orderdetail = false;
        },
        setCurrency(total) {
            return total.replace(".", ",") + ' ' + this.moneySign;
        },
        downloadInvoice(orderId) {
            this.downloadInvoiceReceipt(orderId);
        }
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    }
}
</script>